import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Link } from "react-router-dom";
import { Video } from "lucide-react";

export default function AdminVideoOps() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    (async () => { const { data } = await api.get("/analytics/admin/video-opportunities"); setRows(data); })();
  }, []);
  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-3xl tracking-tight">Video Çekilecek Sorular</h1>
        <p className="text-slate-400 text-sm">Yüksek hata oranı olup henüz çözüm videosu olmayan sorular.</p>
      </div>
      <div className="border border-[#262626] rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#171717] text-slate-400 text-xs uppercase">
            <tr><th className="text-left p-3">Ref</th><th className="text-left p-3">Metin</th><th className="text-left p-3">Denenen</th><th className="text-left p-3">Hata %</th><th className="p-3"/></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.question_id} className="border-t border-[#262626] hover:bg-[#171717]">
                <td className="p-3 font-mono">{r.ref}</td>
                <td className="p-3 max-w-md truncate">{r.text}</td>
                <td className="p-3">{r.attempts}</td>
                <td className="p-3 text-rose-400">{r.error_rate}%</td>
                <td className="p-3 text-right">
                  <Link to={`/admin/sorular/${r.question_id}`} className="inline-flex items-center gap-1 text-[#EA580C] hover:underline">
                    <Video size={14}/> Video ekle
                  </Link>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-slate-500">Şu an kritik bir soru yok.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
